export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7248.6d8229d7.jpg";